// extracted by mini-css-extract-plugin
export default {"imageSection":"ImageSection_imageSection__UUUdd"};